import LegalPageLayout, { type LegalSection } from '../components/layout/LegalPageLayout';
import Seo from '../components/Seo';
import '../styles/legal-pages.css';
import './CookiesPage.css';

const sections: LegalSection[] = [
  { id: 'what', title: '1. Что такое cookies' },
  { id: 'types', title: '2. Какие cookies мы используем' },
  { id: 'table', title: '3. Таблица cookies' },
  { id: 'manage', title: '4. Как управлять cookies' },
  { id: 'third', title: '5. Cookies третьих сторон' },
  { id: 'contacts', title: '6. Контакты' },
];

export default function CookiesPage() {
  return (
    <LegalPageLayout
      title="Политика использования Cookies"
      updatedAt="28 января 2026 г."
      version="1.0"
      sections={sections}
    >
      <Seo
        title="Политика использования Cookies — Recvisit"
        description="Информация о cookies на сайте Recvisit: типы cookies, управление согласием и аналитика (Яндекс.Метрика)."
        canonicalPath="/cookies"
      />
      <section id="what" className="legal-section">
        <h2>1. Что такое cookies</h2>
        <p>
          Cookies — это небольшие текстовые файлы, которые сохраняются в браузере при посещении сайта. Они помогают
          обеспечить корректную работу сайта, запоминать ваши настройки и (с вашего согласия) собирать обезличенную
          статистику использования для улучшения сервиса.
        </p>
      </section>

      <section id="types" className="legal-section">
        <h2>2. Какие cookies мы используем</h2>
        <h3>2.1. Технические (обязательные)</h3>
        <p>
          Нужны для базовой работоспособности сайта и функций авторизации. Отключение таких cookies может привести к
          некорректной работе отдельных функций.
        </p>

        <h3>2.2. Аналитические (по согласию)</h3>
        <p>
          Используются для сбора обезличенной статистики и улучшения сайта (например, Яндекс.Метрика). Аналитика
          включается только после получения согласия через баннер cookies.
        </p>

        <h3>2.3. Функциональные (по согласию)</h3>
        <p>Используются для запоминания настроек интерфейса и предпочтений (при наличии таких функций).</p>
      </section>

      <section id="table" className="legal-section">
        <h2>3. Таблица cookies</h2>
        <div className="cookies-table-wrap">
          <table className="cookies-table">
            <thead>
              <tr>
                <th>Название</th>
                <th>Тип</th>
                <th>Срок</th>
                <th>Цель</th>
                <th>Домен</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>recvi_cookie_consent_v1</code></td>
                <td>Технический</td>
                <td>1 год</td>
                <td>Хранение выбора согласия на cookies</td>
                <td>recvi.ru</td>
              </tr>
              <tr>
                <td><code>_ym_uid</code></td>
                <td>Аналитический</td>
                <td>1 год</td>
                <td>Яндекс.Метрика — уникальный идентификатор посетителя</td>
                <td>.recvi.ru</td>
              </tr>
              <tr>
                <td><code>_ym_d</code></td>
                <td>Аналитический</td>
                <td>1 год</td>
                <td>Яндекс.Метрика — дата первого визита</td>
                <td>.recvi.ru</td>
              </tr>
              <tr>
                <td><code>_ym_isad</code></td>
                <td>Аналитический</td>
                <td>1 день</td>
                <td>Яндекс.Метрика — определение блокировщиков рекламы</td>
                <td>.recvi.ru</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="cookies-note">
          Примечание: перечень cookies может меняться при обновлении сайта/сервиса. Актуальный выбор аналитики задается
          через баннер cookies.
        </p>
      </section>

      <section id="manage" className="legal-section">
        <h2>4. Как управлять cookies</h2>
        <p>
          Вы можете изменить выбор аналитических/функциональных cookies в баннере cookies (кнопка «Настроить» при первом
          визите). Также вы можете ограничить или удалить cookies в настройках браузера.
        </p>
        <ul>
          <li>Chrome: Настройки → Конфиденциальность и безопасность → Файлы cookie</li>
          <li>Firefox: Настройки → Приватность и защита → Куки и данные</li>
          <li>Safari: Настройки → Конфиденциальность</li>
          <li>Edge: Настройки → Конфиденциальность → Файлы cookie</li>
        </ul>
      </section>

      <section id="third" className="legal-section">
        <h2>5. Cookies третьих сторон</h2>
        <p>
          При согласии на аналитику сайт может использовать Яндекс.Метрику (ID: 105619677). Политика конфиденциальности
          Яндекса: <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">yandex.ru/legal/confidential</a>.
          Отказ от учета: <a href="https://yandex.ru/support/metrica/general/opt-out.html" target="_blank" rel="noopener noreferrer">yandex.ru/support/metrica/general/opt-out</a>.
        </p>
      </section>

      <section id="contacts" className="legal-section">
        <h2>6. Контакты</h2>
        <p>
          По вопросам cookies: <a href="mailto:info@recvi.ru">info@recvi.ru</a>.
        </p>
      </section>
    </LegalPageLayout>
  );
}

